type JsonLogicValue =
    | string
    | number
    | boolean
    | null
    | JsonLogicValue[]
    | { [key: string]: JsonLogicValue };

function isQuestionOptionVar(node: JsonLogicValue): node is { var: string } {
    return (
        !!node &&
        typeof node === 'object' &&
        !Array.isArray(node) &&
        'var' in node &&
        typeof (node as { var?: unknown }).var === 'string' &&
        /^question_[0-9a-fA-F-]+_option$/.test((node as { var: string }).var)
    );
}

function isOptionArray(value: JsonLogicValue): value is string[] {
    return (
        Array.isArray(value) &&
        value.every((item) => typeof item === 'string' && item.startsWith('option_'))
    );
}

function transformInOperatorForQuestionOption(node: JsonLogicValue): JsonLogicValue {
    if (Array.isArray(node)) {
        return node.map((item) => transformInOperatorForQuestionOption(item));
    }

    if (!node || typeof node !== 'object') {
        return node;
    }

    const nodeAsObject = node as Record<string, JsonLogicValue>;

    if ('in' in nodeAsObject) {
        const inValue = nodeAsObject.in;

        if (Array.isArray(inValue) && inValue.length === 2) {
            const [left, right] = inValue;

            if (isQuestionOptionVar(left) && isOptionArray(right)) {
                return {
                    or: right.map((optionValue) => ({
                        in: [optionValue, left],
                    })),
                };
            }
        }
    }

    const result: Record<string, JsonLogicValue> = {};
    for (const [key, value] of Object.entries(nodeAsObject)) {
        result[key] = transformInOperatorForQuestionOption(value);
    }

    return result;
}

export function normalizeLogicForQuestionMultiSelect(rawLogic: string): string {
    const parsed = JSON.parse(rawLogic) as JsonLogicValue;
    const transformed = transformInOperatorForQuestionOption(parsed);
    return JSON.stringify(transformed);
}
